export class AvailableBank {
  name = '';
  paymentMethod = '';
  priority = null;
}

export class SavedCard {
  cardNumber = '';
  nameOnCard = '';
  cardExpYear = '';
  cardExpMonth = '';
  cardSecurityCode = '';
  nickname = '';
  cardToken = '';
  cardReference = '';
  cardFingerprint = '';
  cardIsin = '';
  lastFourDigits = '';
  cardType = '';
  cardIssuer = '';
  savedToLocker: boolean;
  expired: boolean;
  cardBrand = '';
}

export enum IframeElement {
  card_number = <any>'.card_number_div',
  card_name = <any>'.name_on_card_div',
  expiry_month = <any>'.card_exp_month_div',
  expiry_year = <any>'.card_exp_year_div',
  cvv = <any>'.security_code_div'
}

export enum PaymentMethod {
  NetBanking = <any>'NB',
  Card = <any>'CARD'
}


